import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { AirlineFormView } from './airline-form.view';
import { AirlineDataService } from './airline-form.data';

interface AirlineFormParams {
	id: string
}

@observer
export class AirlineFormController extends React.Component<ControllerProps<AirlineFormParams>, any>  {
	@observable
	protected dataService: AirlineDataService;

	@observable
	mode: ControlMode = 'display';
	
	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
		this.dataService = AirlineDataService.make();
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item) {
			return `Airline ${this.dataService.item.title}`;
		}
		return '';
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.mode = mode;
	}

	@autobind
	protected create() {
		const airline = this.dataService.add();
		return airline;
	}

    @autobind
    public async save() {
        const item = this.dataService.item;
        const errors = await item.validate(true);
        if (errors.length == 0) {
            this.props.setBusy(true);

            this.dataService.save()
                .then(() => {
                    this.props.setBusy(false);
                    this.onModeChanged('display');
                    this.toast.showDataSaved();
                    this.props.history.replace(`/general/airlines`);
                })
                .catch((error) => {
                    this.props.setBusy(false);
                    this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
                });
        } else {
            this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
        }
    }

	@autobind
	public cancel() {
		this.props.history.push('/general/airlines');
	}

    componentDidMount() {
        this.props.setBusy(true);
        if (this.props.match.params.id == 'new') {
            // Create new
            this.dataService.create(this.create)
                .then(() => {
                    this.mode = 'edit';
                    this.props.setBusy(false);

                }).catch(error => {
                    this.props.setBusy(false);
                    this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
                });
        } else {
            // Load entity
            this.dataService.addFilter('id', 'eq', this.props.match.params.id);
            this.dataService.addSorting('id', 'asc', true);
            this.dataService.pageSize = 1;
            this.dataService.load(query => query)
                .catch((error) => {
                    this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
                })
                .then(() => {
                    this.props.setBusy(false)
                });
        }
    }

    render() {
        return (
			<AirlineFormView title={this.title}
				mode={this.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService.item}
				setBusy={this.props.setBusy}
				contextService={this.dataService}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/form/airline-form.controller.tsx